<template>
  <div
    :class="[{'child-item': parent}, 'checkbox-btn']"
  >
    <el-form-item
      :class="[{'is-required': required == 'Required'}, columns]"
    >
      <div
        v-if="!rows"
      >
        <div
          v-for="(param, num) in variants"
          :key="num"
        >
          <el-checkbox
            v-model="model"
            @change="passData(qfid, model)"
            :label="param.label"
            border
          >
            {{ label }}
          </el-checkbox>
        </div>
      </div>
      <div
        v-if="rows"
        class="checkbox-group"
      >
        <div
          v-for="(param, num) in variants"
          :key="num"
          class="column"
        >
          <span>
            {{ label }}
          </span>
          <div
            v-for="(value, index) in variantBlock"
            :key="index"
          >
            <el-checkbox
              v-model="value.model"
              @change="passData(value.fid, value.model)"
              :label="param.label"
              border
            >
              {{ param.label }}
            </el-checkbox>
          </div>
        </div>
      </div>
      <span
        class="error"
        v-if="showError"
      >
        {{ errorMsg }}
      </span>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "CheckBoxBtn",
  data () {
    return {
      model: null,
      errorMsg: '',
      showError: false
    };
  },
  props: {
    id: { type: Number, default: () => { return null } },
    qfid: { type: String, default: () => { return '' } },
    select: { type: Boolean, default: () => { return true } },
    name: { type: String, default: () => { return '' } },
    names: { type: Array, default: () => { return [] } },
    variantBlock: { type: Array, default: () => { return [] } },
    postfix: { type: String, default: () => { return '' } },
    rows: { type: Boolean, default: () => { return false } },
    label: { type: String, default: () => { return '' } },
    required: { type: String, default: () => { return '' } },
    columns: { type: String, default: () => { return '' } },
    variants: { type: Array, default: () => { return [] } },
    condition: { type: String, default: () => { return '' } },
    parent: { type: Boolean, default: () => { return false } },
  },
  created () {
    this.errorMsg = this.$t('common.errors.required');
    if (!this.rows) {
      this.model = this.name ? this.name : this.qfid + '_' + this.postfix;
      this.model = this.select;
    } else {
      this.names.forEach((item) => {
        this.variantBlock.push({model: item[item.name], fid: item.fid});
      });
    }
  },
  methods: {
    passData(fid, model) {
      this.$set(this, 'showError', false);
      let data = {
        findingId: fid,
        findingType: 'CheckBox',
        yNResultFlag: model ? 'Y' : 'N',
        findingValue: '',
        ClinicalLookupCode: ''
      }
      this.$emit('passData', {
        data: data,
        condition: this.condition,
        model: model,
        required: this.required,
        id: this.id
      })
    },
  }
}
</script>
